import { ComponentAPI } from '@philips-emr/tws-core';

export default class HpmsTextHtmlAPI extends ComponentAPI<{ value: string }> {

  setValue(value: string): void {
    this.setState({ value });
  }
}
